import React, { createContext, useState } from 'react';
import { WaitingQueue, CurrentUserData } from '../../apis/createWaitingQueue'
type ProviderDetailContextType = {
    isAccessAdmit: boolean;
    participantType: string;
    setAccessAdmit: (isAccessAdmit: boolean) => void;
    setParticipant: (participantType: string) => void;
    socket: any;
    currentUser: CurrentUserData | null;
    setCurrentUser: (currentUser: CurrentUserData | null) => void;
    waitingCount: number;
    setCountWaitingUser: (waitingCount: number) => void;
    listWaiting: any;
    setListWaiting: (listWaiting: any) => void;
    appointmentInfo: any;
    setAppointmentInfo: (appointmentInfo: any) => void;
    upcoming: any;
    setupcoming: (upcoming: any) => void;
    currentAppointment: any;
    setcurrentAppointment: (currentAppointment: any) => void;
    waitingList: any;
    setWaitingGroup: (waitingList: any) => void;

};

export const ProviderDetailContext = createContext<ProviderDetailContextType>(null!);
//@ts-ignore
export const ProviderDetail: React.FC = ({ socket, children }) => {

    const [isAccessAdmit, setAccessAdmit] = useState(false);
    const [currentUser, setCurrentUser] = useState<CurrentUserData | null>(null)
    const [waitingCount, setCountWaitingUser] = useState<number>(0);
    const [listWaiting, setListWaiting] = useState<Array<WaitingQueue> | []>([]);
    const [waitingList, setWaitingGroup] = useState<Array<any> | []>([]);
    const [appointmentInfo, setAppointmentInfo] = useState<any>({ });
    const [participantType, setParticipant] = useState('');
    const [upcoming, setupcoming] = useState<any>();
    const [currentAppointment, setcurrentAppointment] = useState<any>();

    return (
        <ProviderDetailContext.Provider
            value={{
                isAccessAdmit,
                participantType,
                setAccessAdmit,
                setParticipant,
                socket,
                currentUser,
                setCurrentUser,
                waitingCount,
                setCountWaitingUser,
                listWaiting,
                setListWaiting,
                appointmentInfo,
                setAppointmentInfo,
                setupcoming,
                upcoming,
                currentAppointment,
                setcurrentAppointment,
                waitingList,
                setWaitingGroup
            }}
        >
            {children}
        </ProviderDetailContext.Provider>
    );
};
